import { motion } from "framer-motion";
import Reveal from "./Reveal";
import { APP_STORE_URL } from "../content";
import { Sticker } from "./Stickers";

const LINES = ["Press-ons are an industry.", "The infrastructure should be too."];

export default function Statement() {
  return (
    <section
      className="border-y-2 border-ink bg-pastel-blue text-ink"
      data-testid="statement-band"
    >
      <div className="mx-auto max-w-7xl px-6 py-24 md:px-16 md:py-32">
        <Sticker rotate="rotate-2" className="mb-10 bg-white">
          The standard
        </Sticker>

        <motion.h2
          className="font-display text-[clamp(2rem,5vw,4.2rem)] font-extrabold leading-[1.02] tracking-tight"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          {LINES.map((line, i) => (
            <span
              key={line}
              className="block overflow-hidden pb-[0.09em] -mb-[0.09em]"
            >
              <motion.span
                className={`block ${i === LINES.length - 1 ? "text-pastel-pink" : ""}`}
                variants={{
                  hidden: { y: "112%" },
                  visible: {
                    y: 0,
                    transition: {
                      duration: 1,
                      delay: i * 0.16,
                      ease: [0.16, 1, 0.3, 1],
                    },
                  },
                }}
              >
                {line}
              </motion.span>
            </span>
          ))}
        </motion.h2>

        <Reveal delay={0.2}>
          <p className="mt-8 max-w-xl text-lg leading-relaxed text-ink/70">
            nailtape™ is the business infrastructure for the modern press-on
            industry — digital nail sizing, client measurements, orders,
            workflow and analytics, together.
          </p>
        </Reveal>

        <Reveal delay={0.3}>
          <div className="mt-10 flex flex-wrap items-center gap-6">
            <a
              data-testid="statement-appstore-btn"
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-full border-2 border-ink bg-ink px-8 py-4 font-display text-sm font-bold uppercase tracking-tight text-bone shadow-chunk transition-all duration-200 hover:-translate-y-0.5 hover:bg-pastel-pink hover:text-ink hover:shadow-chunk-lg"
            >
              Get nailtape™
            </a>
            <a
              data-testid="statement-explore-link"
              href="#features"
              className="group font-display text-sm font-bold uppercase tracking-tight text-ink"
            >
              Explore the platform
              <span className="mt-0.5 block h-[3px] w-full origin-left scale-x-100 bg-ink transition-transform duration-300 group-hover:scale-x-50" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
